import { useState } from 'react';
import AuthShell from './AuthShell';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const RegisterScreen = ({ api, onNav }) => {
  const [form, setForm] = useState({ display_name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) return setError('Password must be at least 8 characters');
    if (form.password !== form.confirm) return setError('Passwords don’t match');
    setIsLoading(true);
    try {
      await api.post('/auth/register', {
        display_name: form.display_name, email: form.email, password: form.password,
      });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not create account');
    } finally {
      setIsLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Check your email"
        footer={<button onClick={() => onNav('login')} className="text-primary hover:underline">Back to sign in</button>}>
        <p className="text-sm text-muted-foreground text-center">
          We sent a verification link to <span className="text-foreground font-medium">{form.email}</span>.
          Click it to activate your account, then sign in.
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Create your account"
      footer={<>Already have an account? <button onClick={() => onNav('login')} className="text-primary hover:underline">Sign in</button></>}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input id="name" value={form.display_name} onChange={set('display_name')} required autoFocus />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={form.email} onChange={set('email')} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={form.password} onChange={set('password')} required />
          <p className="text-xs text-muted-foreground">At least 8 characters.</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" type="password" value={form.confirm} onChange={set('confirm')} required />
        </div>
        {error && <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md text-center">{error}</div>}
        <Button type="submit" disabled={isLoading} className="w-full">
          {isLoading ? 'Creating…' : 'Create account'}
        </Button>
      </form>
    </AuthShell>
  );
};

export default RegisterScreen;
